import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const explorerBadgeDefinition: BoggleBadgeDefinition = {
  category: 'path',
  description: 'Clear tiles from 10 different positions in a row',
  iconId: 'explorer',
  id: 'explorer',
  level: 'uncommon',
  lockedReveal: 'reveal',
  name: 'Explorer',
  points: getBoggleBadgePointsForLevel('uncommon'),
}
